import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './ProjectOpenItemDetails.css';
import { SlideDown } from 'react-slidedown';
import DocumentLink from 'components/shared/document/DocumentLink';
import LogoUpload from 'components/shared/logo-upload/LogoUpload';
import Button from 'components/shared/button/Button';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';
import { setShowEmailModal } from 'components/admin/projects/details/project-email-modal/store/actions';
import printSvg from 'images/print.svg';
import mailSvg from 'images/mail.svg';
import { Enterprise } from 'domain/enterprise';
import { getCurrentUser } from 'selectors/authentication';
import { getCurrentProject } from 'components/admin/projects/details/store/selectors';
import {
  getCurrentProjectOpenItem,
  getRespondOpenItemDetailsModal,
} from 'components/admin/projects/details/project-open-items/store/selectors';
import {
  setOpenItemForm,
  respondOpenItemDetailsModal,
  cancelRespondOpenItemDetailsModal,
  respondProjectOpenItem,
  setOpenItemPdfViewer,
} from 'components/admin/projects/details/project-open-items/store/actions';
import ProjectOpenItemNotes from 'components/admin/projects/details/project-open-items/ProjectOpenItemNotes';
import ProjectOpenItemRespondForm from 'components/admin/projects/details/project-open-items/ProjectOpenItemRespondForm';

class ProjectOpenItemDetails extends Component {
  static propTypes = {
    onDelete: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
  };

  handleRespond = () => {
    const { openItem, dispatch } = this.props;
    dispatch(
      setOpenItemForm({
        ...openItem,
        documents: openItem.response_documents.map((doc) => {
          return {
            ...doc,
            url: doc.document.url,
          };
        }),
        images: openItem.response_images.map((image) => {
          return {
            ...image,
            url: image.image.gallery.url,
          };
        }),
      })
    );
    dispatch(respondOpenItemDetailsModal());
  };

  handleRespondCancel = () => {
    this.props.dispatch(cancelRespondOpenItemDetailsModal());
  };

  handleRespondSave = (values) => {
    const { currentProject, openItem, dispatch } = this.props;
    dispatch(respondProjectOpenItem(currentProject.id, openItem.id, values));
  };

  showUnreadNotesIndicator = () => {
    const { currentUser, openItem } = this.props;
    const notesReadBy = openItem.notes_read_by;
    return (
      notesReadBy &&
      notesReadBy.length > 0 &&
      !notesReadBy.find((readById) => readById === `${currentUser.id}`)
    );
  };

  handleViewPdf = () => {
    const { dispatch } = this.props;
    dispatch(setOpenItemPdfViewer(true));
  };

  handleShowEmailModal = () => {
    this.props.dispatch(setShowEmailModal(true));
  };

  render() {
    const {
      currentUser,
      currentProject,
      openItem,
      respondOpenItemDetailsModal,
      onDelete,
      onEdit,
    } = this.props;
    const spackleOrGc = Enterprise.spackleOrGc(currentProject.contributor_type);
    const creator =
      openItem &&
      openItem.created_by &&
      openItem.created_by.id === currentUser.id;
    const assignee = openItem && openItem.assignee_id === currentUser.id;
    const manager = (spackleOrGc && !assignee) || creator;
    return (
      openItem && (
        <Row className="project-open-item-details">
          <Col sm={7}>
            <div className="project-open-item-details-block">
              {(openItem.created_by || openItem.assignee_label) && (
                <div className="project-open-item-title-block">
                  <p className="project-open-item-block-title">
                    {openItem.created_by && (
                      <span>
                        From: {openItem.created_by.first_name}{' '}
                        {openItem.created_by.last_name}
                      </span>
                    )}
                    {openItem.assignee_label && (
                      <span>Assigned To: {openItem.assignee_label}</span>
                    )}
                  </p>
                </div>
              )}
              {openItem.recipients && openItem.recipients.length > 0 && (
                <div className="project-open-item-title-block">
                  <p className="project-open-item-block-title">
                    CC Recipient(s):{' '}
                    {openItem.recipients
                      .map((rcpt) => `${rcpt.first_name} ${rcpt.last_name}`)
                      .join(', ')}
                  </p>
                </div>
              )}
              <div className="project-open-item-title-block">
                <p className="project-open-item-block-title">
                  <span>
                    Created: {moment(openItem.created_at).format('MM/DD/YY')}
                  </span>
                  {openItem.resolve_by && (
                    <span>
                      Due Date: {moment(openItem.resolve_by).format('MM/DD/YY')}
                    </span>
                  )}
                  <span>
                    Status: {openItem.resolved ? 'Resolved' : 'Pending'}
                  </span>
                </p>
              </div>
              <div className="project-open-item-details-block">
                <div className="project-open-item-text-block">
                  {openItem.description}
                </div>
              </div>
              {openItem.documents && openItem.documents.length > 0 && (
                <div className="project-open-item-details-block">
                  {openItem.documents.map((doc, index) => {
                    return (
                      <div className="doc-viewer" key={index}>
                        <DocumentLink url={doc.document.url} />
                      </div>
                    );
                  })}
                </div>
              )}
              {openItem.images && openItem.images.length > 0 && (
                <div className="project-open-item-details-block">
                  <div className="project-open-item-block-images-wrapper">
                    <LogoUpload
                      readOnly
                      logos={openItem.images.map((image) => ({
                        preview: image.image.gallery.url,
                        url: image.image.url,
                      }))}
                    />
                  </div>
                </div>
              )}
              {(openItem.response || respondOpenItemDetailsModal) && (
                <div className="divider"></div>
              )}
              {respondOpenItemDetailsModal ? (
                <SlideDown>
                  <ProjectOpenItemRespondForm
                    onSave={this.handleRespondSave}
                    onCancel={this.handleRespondCancel}
                  />
                </SlideDown>
              ) : (
                <div className="project-open-item-details-response">
                  <div className="project-open-item-title-block">
                    <p className="project-open-item-block-title">
                      {openItem.responded_at && (
                        <span>
                          Responded:{' '}
                          {moment(openItem.responded_at).format('MM/DD/YY')}
                        </span>
                      )}
                      {openItem.draft_response && <span>Draft Response</span>}
                    </p>
                  </div>
                  <div className="project-open-item-details-block">
                    <div className="project-open-item-text-block">
                      {openItem.response}
                    </div>
                  </div>
                  {openItem.response_documents &&
                    openItem.response_documents.length > 0 && (
                      <div className="project-open-item-details-block">
                        {openItem.response_documents.map((doc, index) => {
                          return (
                            <div className="doc-viewer" key={index}>
                              <DocumentLink url={doc.document.url} />
                            </div>
                          );
                        })}
                      </div>
                    )}
                  {openItem.response_images &&
                    openItem.response_images.length > 0 && (
                      <div className="project-open-item-details-block">
                        <div className="project-open-item-block-images-wrapper">
                          <LogoUpload
                            readOnly
                            logos={openItem.response_images.map((image) => ({
                              preview: image.image.gallery.url,
                              url: image.image.url,
                            }))}
                          />
                        </div>
                      </div>
                    )}
                </div>
              )}
            </div>
            {!respondOpenItemDetailsModal && (
              <div className="buttons-container">
                {manager && !openItem.responded_at && (
                  <Button
                    label="Delete"
                    className="button-white"
                    onClick={onDelete}
                  />
                )}
                {openItem && (
                  <Button
                    className="button-white"
                    icon={mailSvg}
                    label="Email"
                    onClick={this.handleShowEmailModal}
                  />
                )}
                {openItem.pdf_document && (
                  <Button
                    className="button-white"
                    icon={printSvg}
                    label="View PDF"
                    onClick={this.handleViewPdf}
                  />
                )}
                {spackleOrGc && !assignee ? (
                  <Button
                    label="GC Acceleration"
                    className="button-white"
                    onClick={this.handleRespond}
                  />
                ) : (
                  assignee &&
                  !openItem.resolved && (
                    <Button
                      label={
                        openItem.responded_at || openItem.draft_response
                          ? 'Edit Response'
                          : 'Respond'
                      }
                      className="button-orange"
                      onClick={this.handleRespond}
                    />
                  )
                )}
                {manager && (
                  <Button
                    label={
                      openItem.responded_at && !openItem.draft_response
                        ? 'Edit or Resolve'
                        : 'Edit'
                    }
                    className="button-orange"
                    onClick={onEdit}
                  />
                )}
              </div>
            )}
          </Col>
          <Col sm={5}>
            <ProjectOpenItemNotes />
          </Col>
        </Row>
      )
    );
  }
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
    currentProject: getCurrentProject(state),
    openItem: getCurrentProjectOpenItem(state),
    respondOpenItemDetailsModal: getRespondOpenItemDetailsModal(state),
  };
})(ProjectOpenItemDetails);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-open-items/ProjectOpenItemDetails.js